import { styled } from "@mui/system";

export const SpacingDivider = styled("div")<{ $spacing: number }>(
  ({ theme, $spacing }) => `
  height: ${theme.spacing($spacing)};
  width: 100%;
`
);
